export const PRODUCT_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "catalog/api",
  CATEGORIES: "categories",
  PRODUCTS: "products",
  SUGGESTIONS: "suggestions",
};
